export default "__VITE_ASSET__Cxvpwlnq__"